import { z } from "zod";

const publishingFormDetailsSchema = z.object({
  displayName: z.string().min(1, "Common:requiredField"),
  description: z.string().min(1, "Common:requiredField"),
  locale: z.enum(["En", "Ar"]),
});

export const createTemplatesFormSchema = z.object({
  status: z.enum(["Active", "InActive"]),
  typeOfScientificId: z.number({ message: "Common:requiredField" }).int().min(1, "Common:requiredField"),
  scientificClassificationId: z.number({ message: "Common:requiredField" }).int().min(1, "Common:requiredField"),
  jsonSchema: z.string().nullable(),
  publishingFormDetails: z.array(publishingFormDetailsSchema),
});

export type CreatePublishingFormRequest = z.infer<typeof createTemplatesFormSchema>;
